import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import styled, { css } from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 8px;
  ${({ isMobile }) => {
    return (
      isMobile &&
      css`
        flex-direction: column;
      `
    );
  }}
`;

const InputError = styled.div`
  color: ${select('redNoTRecommended')};
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  margin-top: 4px;
  position: absolute;
  bottom: -20px;
  left: 0;
  ${({ isMobile }) =>
    isMobile &&
    css`
      bottom: -20px;
    `};
`;

const CustomInput = styled.input`
  height: 40px;
  width: ${({ isMobile }) => (isMobile ? '100%' : '54px')};
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${select('midDarkGrayAux')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${select('midDarkGrayAux')};
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  visibility: ${({ showInput }) => (showInput ? 'visible' : 'hidden')};
  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid ${select('redNoTRecommended')};
    `};
  &:focus {
    border: 1px solid ${getColor('primary')};
  }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export { Container, CustomInput, InputError, InputContainer };
